import {z} from 'zod';

export const MeasurementUnitFormSchema = z.object({
  name: z.string(),
  description: z.string().nullish(),
  isDefault: z.boolean(),
  isActive: z.boolean(),
});

export type MeasurementUnitForm = z.infer<typeof MeasurementUnitFormSchema>;
